<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <template v-if="loading">
      <Load :loading-msg="loadingMsg" />
    </template>
    <template v-else>
      <v-card>
        <v-card-title>
          Cadastro do Usuário
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
          >
            <v-text-field
              v-model="dataUser.name"
              prepend-icon="mdi-account"
              :error-messages="formErrors.name"
              :rules="rulesName"
              label="Nome"
              @input="formErrors.name = ''"
            />
            <v-text-field
              v-model="dataUser.email"
              prepend-icon="mdi-email"
              label="E-mail de acesso"
              :error-messages="formErrors.email"
              :rules="rulesEmail"
              @input="formErrors.email = ''"
            />
            <v-text-field
              v-model="dataUser.password"
              prepend-icon="mdi-lock"
              type="password"
              label="Senha"
              :error-messages="formErrors.password"
              :rules="rulesPassword"
              @input="formErrors.password = ''"
            />
            <v-switch
              v-model="dataUser.status"
              class="ma-2"
              :label="dataUser.status ? 'Ativo' : 'Inativo'"
            />
          </v-form>
          <div class="d-flex justify-space-between">
            <v-btn
              color="primary"
              text
              @click="onCancel"
            >
              fechar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="save()"
            >
              Salvar
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import Load from '@/components/Loading.vue'

export default {
  components: {
    Load
  },

  mixins: [
    handlesServerValidation
  ],

  data: () => ({
    rulesName: [
      value => !!value || 'Nome é obrigatório.',
      value => (value && value.length >= 1) || 'Min 3 caracteres'
    ],
    rulesEmail: [
      v => !!v || 'E-mail é obrigatório',
      v => /.+@.+\..+/.test(v) || 'E-mail inválido'
    ],
    rulesPassword: [
      value => !!value || 'Senha é obrigatória.'
      // value => (value && value.length >= 8) || 'Min 8 caracteres'
    ],
    dataUser: {
      name: undefined,
      email: undefined,
      password: undefined,
      status: true
    },
    loading: false,
    loadingMsg: ''
  }),
  methods: {
    validate () {
      return this.$refs.form.validate()
    },
    close () {
      this.$emit('close')
    },

    async save () {
      const validate = await this.validate()
      if (validate === false) {
        return false
      }
      const data = {
        name: this.dataUser.name,
        email: this.dataUser.email,
        password: this.dataUser.password,
        status: this.dataUser.status
      }
      this.newIntranetUser(data)
    },

    async newIntranetUser (data) {
      this.loading = true
      try {
        const response = await this.$api.newUser(data)
        this.onSubmit(response)
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível criar o usuário, tente novamente mais tarde.', color: 'red' })
      } finally {
        this.loading = false
      }
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    onSubmit (data) {
      this.$emit('resolve', data)
    }
  }
}
</script>
